import { useEffect, useRef, useState } from 'react';

export function useWebSocket({ token, onMessage }) {
  const [status, setStatus] = useState("disconnected");
    const socketRef = useRef(null);
  const reconnectDelayRef = useRef(1000); // start with 1 second
  const reconnectTimeoutRef = useRef(null);
  const pingIntervalRef = useRef(null);

  const connectWebSocket = () => {
        if (!token) return;

    const wsUrl = `wss://api.tbot.co.in/ws`;
        setStatus("connecting");

    const socket = new WebSocket(wsUrl, [`token-${token}`]);
        socketRef.current = socket;

        socket.onopen = () => {
      console.log("✅ WebSocket connected");
            setStatus("connected");
      reconnectDelayRef.current = 1000;

      // 🔁 Start sending periodic pings
      pingIntervalRef.current = setInterval(() => {
        if (socketRef.current?.readyState === WebSocket.OPEN) {
          socketRef.current.send("ping");
        }
      }, 10000); // every 10 seconds
        };

        socket.onmessage = (event) => {
      if (event.data === "pong") {
        console.debug("🟢 Pong received");
        return;
      }
      if (onMessage) onMessage(event.data);
        };

        socket.onerror = (err) => {
            console.error("WebSocket error:", err);
        };

        socket.onclose = () => {
      console.warn("🔌 WebSocket disconnected");
      setStatus("reconnecting");

      // ⏹ Stop pinging
      clearInterval(pingIntervalRef.current);

      // Retry connection with exponential backoff
      reconnectTimeoutRef.current = setTimeout(() => {
        reconnectDelayRef.current = Math.min(reconnectDelayRef.current * 2, 30000);
        connectWebSocket();
      }, reconnectDelayRef.current);
        };
  };

  useEffect(() => {
    connectWebSocket();

        return () => {
      clearTimeout(reconnectTimeoutRef.current);
      clearInterval(pingIntervalRef.current);
      socketRef.current?.close();
        };
  }, [token]);

  return {
    socket: socketRef.current,
    status,
  };
}
